import React from "react";
import {
    Button,
    Loader,
    Card,
    CardBody,
    CardHeader,
    Dropdown,
    GdAutocomplete,
    Input,
    StateOptions,
    Toast,
    Icon,
    Tooltip
} from "gd-react";
import SaveBar from "../../components/SaveBar/SaveBar";
import DeleteModal from "../../modals/Delete/DeleteModal";
import GridDuck from 'gridduck'
import Toggle from "../../components/Toggle/Toggle";
import history from "../../meta/history";
import AddEditDeviceCategoryModal from "../../modals/AddEditDeviceCategory/AddEditDeviceCategoryModal";
import GenericLoader from "../../components/GenericLoader";
import ForwardDataTypesDrawer from "../../components/ForwardDataTypesEditor/ForwardDataTypesDrawer";
import './AssetPage.scss'
import ModifiersModal from "../../components/ModifiersDrawer/ModifiersModal";
import EditChoicePopover from '../../components/ModifiersDrawer/EditChoicePopover';
import ModifierSourceSelector from '../../components/ModifiersDrawer/ModifierSourceSelector';

class AssetSettingsDetails extends React.Component {
    constructor(props) {
        super(props);
        this.setAssetDetails = this.setAssetDetails.bind(this);
        this.onFormChange = this.onFormChange.bind(this);
        this.cancelChanges = this.cancelChanges.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
        this.checkErrors = this.checkErrors.bind(this);
        this.getApplianceTypes = this.getApplianceTypes.bind(this);
        this.showDeleteModal = this.showDeleteModal.bind(this);
        this.selectDeviceCategory = this.selectDeviceCategory.bind(this);
        this.loadTypes = [
            {
                id: 0,
                title: 'Consumption Only',
                value: 'CONSUMPTION'
            },
            {
                id: 1,
                title: 'Generation Only',
                value: 'GENERATION'
            },
            {
                id: 2,
                title: 'Consumption and Export',
                value: 'EXPORT'
            },
        ]
        this.errors = {};
        this.state = {
            loaded: false,
            modbusModels: [],
            asset: {
                name: this.props.item.name,
                impKwh: this.props.item.dataType === 'DELIVERED_GAS' ? 1 / this.props.item.impKwh : this.props.item.impKwh,
                dataType: this.props.item.dataType,
                locked: this.props.item.locked,
                gatewayId: this.props.item.gatewayId,
                gatewayName: this.props.item.gatewayName,
                siteName: this.props.item.siteName,
                modbusType: this.props.item.modbusId,
                loadType: this.loadTypes.find((t) => t.id === this.props.item.loadType)?.value || this.loadTypes[0].value,
                defaultModifiers: this.props.item.defaultModifiers || {},
                siteDefaultModifiers: this.props.item.siteDefaultModifiers || {},
                organisationDefaultModifiers: this.props.item.organisationDefaultModifiers || {},
                modifierLevel: this.props.item.modifierLevel || null
            },
            deviceCategory: {},
            applianceType: this.props.item.applianceType,
            generation: this.props.item.generation,
            applianceTypes: [],
            deviceCategories: [],
            showDeleteModal: false,
            showDeviceCategoryModal: false,
            showModifiersModal: false,
            editingModifier: null,
            editingDefaults: false, // Track if we're editing defaults vs asset-specific
            siteName: this.props.item.siteName,
            gatewayName: this.props.item.gatewayName,
        }
        let self = this;
        GridDuck.getAccount({id: GridDuck.userId})
            .then(function (account) {
                self.setState({account: account});
            });
        this.asset = this.props.item;
        this.getGateways = this.getGateways.bind(this);
        this.getSites = this.getSites.bind(this);
        this.selectGateway = this.selectGateway.bind(this);
        this.selectSite = this.selectSite.bind(this);
        this.syncDeviceCategory = this.syncDeviceCategory.bind(this);
        this.onForwardDataTypesChange = this.onForwardDataTypesChange.bind(this);
        this.showForwardDataTypesDrawer = this.showForwardDataTypesDrawer.bind(this);
        this.hideForwardDataTypesDrawer = this.hideForwardDataTypesDrawer.bind(this);
        this.editCalculatedType = this.editCalculatedType.bind(this);
        this.showModifiersModal = this.showModifiersModal.bind(this);
        this.hideModifiersModal = this.hideModifiersModal.bind(this);
        this.editModifier = this.editModifier.bind(this);
        this.onModifiersChange = this.onModifiersChange.bind(this);
        this.handleEditDefault = this.handleEditDefault.bind(this);
        this.handleEditAsset = this.handleEditAsset.bind(this);
        this.handleModifierSourceSelect = this.handleModifierSourceSelect.bind(this);
        this.getModifierCurrentSource = this.getModifierCurrentSource.bind(this);
        this.getSourceBadge = this.getSourceBadge.bind(this);
    }

    selectSite(s, sObj) {
        if (!s || !sObj) return;
        let asset = this.state.asset;
        asset.groupIds = [sObj.id];
        asset.siteId = sObj.id;
        asset.siteName = sObj.title;
        this.setState({asset: asset, hasChanged: true});
    }

    selectGateway(gw, gwObj) {
        if (!gw || !gwObj) return;
        let asset = this.state.asset;
        asset.gatewayId = gwObj.id;
        asset.gatewayName = gwObj.title;
        this.setState({asset: asset, hasChanged: true});
    }

    syncDeviceCategory(cb) {
        let existingCategory = this.state.deviceCategories.find((c) => c.id === this.props.item.deviceCategoryId)
        if (existingCategory) {
            this.setState({deviceCategory: existingCategory}, () => {
                if (cb) cb();
            });
        } else {
            if (cb) cb();
        }
    }

    onForwardDataTypesChange(forwardDataTypes) {
        // Extract only the custom overrides (the ones that differ from defaults)
        const { customForwardDataTypes } = this.state.asset;
        const { sku } = this.props.item;
        
        // Get default types from StateOptions
        const stateOption = StateOptions.find(t => t.type === sku) || 
                           StateOptions.find(t => t.type === 'default');
        const defaultTypes = stateOption?.forwardDataTypes || {};
        
        // Find which types have been modified from defaults
        const customOverrides = {};
        Object.keys(forwardDataTypes).forEach(key => {
            const defaultType = defaultTypes[key];
            const newType = forwardDataTypes[key];
            
            // If this type doesn't exist in defaults, or if it's different from defaults, save it
            if (!defaultType || JSON.stringify(defaultType) !== JSON.stringify(newType)) {
                customOverrides[key] = newType;
            }
        });
        
        this.setState(prevState => ({
            asset: {
                ...prevState.asset,
                customForwardDataTypes: customOverrides
            },
            hasChanged: true
        }));
    }

    showForwardDataTypesDrawer() {
        this.setState({ showForwardDataTypesDrawer: true });
    }

    hideForwardDataTypesDrawer() {
        this.setState({ showForwardDataTypesDrawer: false, editingCalculatedType: null });
    }

    editCalculatedType(typeKey) {
        this.setState({ 
            showForwardDataTypesDrawer: true, 
            editingCalculatedType: typeKey 
        });
    }

    getAvailableModifiers() {
        const { sku } = this.props.item;
        
        // Get forwardDataTypes from StateOptions based on asset SKU
        const stateOption = StateOptions.find(t => t.type === sku) || 
                           StateOptions.find(t => t.type === 'default');
        
        const forwardDataTypes = stateOption?.forwardDataTypes || {};
        
        // Extract and dedupe modifiers from forwardDataTypes
        const defaultModifiers = {};
        Object.values(forwardDataTypes).forEach(forwardType => {
            if (forwardType.calculation) {
                // The calculation is the modifier object itself
                const modifier = forwardType.calculation;
                
                // Use the modifier's id as the key
                if (modifier.id && !defaultModifiers[modifier.id]) {
                    defaultModifiers[modifier.id] = modifier;
                }
            }
        });
        
        return defaultModifiers;
    }

    getMergedModifiers() {
        const { defaultModifiers, siteDefaultModifiers, organisationDefaultModifiers } = this.state.asset;
        const availableModifiers = this.getAvailableModifiers();
        
        // Merge: platform defaults + org + site + asset (in priority order)
        return {
            ...availableModifiers,
            ...organisationDefaultModifiers,
            ...siteDefaultModifiers,
            ...defaultModifiers
        };
    }

    renderModifiersList() {
        const { defaultModifiers, siteDefaultModifiers, organisationDefaultModifiers } = this.state.asset;
        const mergedModifiers = this.getMergedModifiers();
        const modifierKeys = Object.keys(mergedModifiers);

        if (modifierKeys.length === 0) {
            return (
                <div className="no-modifiers">
                    <p>No modifiers available for this asset type.</p>
                </div>
            );
        }

        return (
            <div className="modifiers-list">
                {modifierKeys.map(key => {
                    const modifier = mergedModifiers[key];
                    const currentSource = this.getModifierCurrentSource(key);
                    const sourceBadge = this.getSourceBadge(currentSource);
                    
                    return (
                        <div key={key} className={`modifier-item ${currentSource !== 'platform' ? 'custom' : 'default'}`}>
                            <div className="modifier-info">
                                <div className="modifier-name">
                                    {this.getModifierDisplayName(key)}
                                    {sourceBadge}
                                </div>
                                <div className="modifier-details">
                                    <span className="description">{modifier.description || 'No description'}</span>
                                    {modifier.finalUnit && (
                                        <span className="unit-badge">
                                            {modifier.finalUnit}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="modifier-actions">
                                <ModifierSourceSelector
                                    modifierKey={key}
                                    modifierName={this.getModifierDisplayName(key)}
                                    currentSource={currentSource}
                                    sourceOptions={this.getModifierSourceOptions(key)}
                                    onSourceSelect={this.handleModifierSourceSelect}
                                >
                                    <Tooltip label="Change Source" position="top">
                                        <Icon
                                            icon="FiSettings"
                                            size={16}
                                            color="gd-blue"
                                            className="icon-button"
                                        />
                                    </Tooltip>
                                </ModifierSourceSelector>
                                {currentSource !== 'platform' && this.checkModifierExists(key, currentSource) && (
                                    <Tooltip label={`Edit ${currentSource === 'asset' ? 'Device-Level' : currentSource === 'site' ? 'Site-Level' : 'Organization-Level'} Settings`} position="top">
                                        <Icon
                                            icon="FiEdit"
                                            size={16}
                                            color="gd-green"
                                            onIconClick={() => this.editModifierAtLevel(key, currentSource)}
                                            className="icon-button"
                                        />
                                    </Tooltip>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }

    getModifierDisplayName(key) {
        const mergedModifiers = this.getMergedModifiers();
        const modifier = mergedModifiers[key];
        
        // Use the modifier's name field if available, otherwise fall back to the key
        return modifier?.name || key;
    }

    onModifiersChange(modifiers, level = 'asset') {
        this.setState(prevState => {
            let updateObject = { ...prevState.asset };
            
            // Only update the specific modifier level that was changed
            switch (level) {
                case 'site':
                    updateObject.siteDefaultModifiers = {
                        ...prevState.asset.siteDefaultModifiers,
                        ...modifiers
                    };
                    break;
                case 'organisation':
                    updateObject.organisationDefaultModifiers = {
                        ...prevState.asset.organisationDefaultModifiers,
                        ...modifiers
                    };
                    break;
                case 'asset':
                default:
                    updateObject.defaultModifiers = {
                        ...prevState.asset.defaultModifiers,
                        ...modifiers
                    };
                    break;
            }
            
            // Update modifierLevel to point to the level we just created/updated
            const modifierKeys = Object.keys(modifiers);
            if (modifierKeys.length > 0) {
                const modifierKey = modifierKeys[0];
                updateObject.modifierLevel = {
                    ...updateObject.modifierLevel,
                    [modifierKey]: level === 'asset' ? 'asset' : level
                };
            }
            
            return {
                asset: updateObject,
                hasChanged: true
            };
        });
    }

    resetModifierToDefault(modifierKey) {
        this.setState(prevState => {
            const newDefaultModifiers = { ...prevState.asset.defaultModifiers };
            const newSiteModifiers = { ...prevState.asset.siteDefaultModifiers };
            const newOrgModifiers = { ...prevState.asset.organisationDefaultModifiers };
            const newModifierLevel = { ...prevState.asset.modifierLevel };
            
            delete newDefaultModifiers[modifierKey];
            delete newSiteModifiers[modifierKey];
            delete newOrgModifiers[modifierKey];
            delete newModifierLevel[modifierKey];
            
            return {
                asset: {
                    ...prevState.asset,
                    defaultModifiers: newDefaultModifiers,
                    siteDefaultModifiers: newSiteModifiers,
                    organisationDefaultModifiers: newOrgModifiers,
                    modifierLevel: newModifierLevel
                },
                hasChanged: true
            };
        });
    }

    editModifier(modifierKey, editDefaults = false) {
        this.setState({ 
            showModifiersModal: true, 
            editingModifier: modifierKey,
            editingDefaults: editDefaults
        });
    }

    editModifierAtLevel(modifierKey, level) {
        // Get the existing modifier data to edit
        let modifierToEdit = null;
        switch (level) {
            case 'asset':
                modifierToEdit = this.state.asset.defaultModifiers[modifierKey];
                break;
            case 'site':
                modifierToEdit = this.state.asset.siteDefaultModifiers[modifierKey];
                break;
            case 'organisation':
                modifierToEdit = this.state.asset.organisationDefaultModifiers[modifierKey];
                break;
        }
        
        this.setState({ 
            showModifiersModal: true, 
            editingModifier: modifierKey,
            editingDefaults: level === 'asset' ? false : level,
            modifierToEdit: modifierToEdit,
            creatingNewModifier: false
        });
    }

    handleEditDefault(modifierKey) {
        this.setState({ 
            showModifiersModal: true, 
            editingModifier: modifierKey,
            editingDefaults: 'org'
        });
    }

    handleEditAsset(modifierKey) {
        this.setState({ 
            showModifiersModal: true, 
            editingModifier: modifierKey,
            editingDefaults: false
        });
    }

    getModifierPriority(modifierKey) {
        const { sku } = this.props.item;
        const stateOption = StateOptions.find(t => t.type === sku) || 
                           StateOptions.find(t => t.type === 'default');
        
        // Priority: StateOptions -> Org -> Site -> Asset
        const stateOptionModifier = this.getModifierFromStateOptions(modifierKey);
        const orgModifier = this.state.asset.organisationDefaultModifiers[modifierKey];
        const siteModifier = this.state.asset.siteDefaultModifiers[modifierKey];
        const assetModifier = this.state.asset.defaultModifiers[modifierKey];
        
        if (stateOptionModifier) return { source: 'stateOptions', modifier: stateOptionModifier };
        if (orgModifier) return { source: 'org', modifier: orgModifier };
        if (siteModifier) return { source: 'site', modifier: siteModifier };
        if (assetModifier) return { source: 'asset', modifier: assetModifier };
        
        return null;
    }

    getModifierFromStateOptions(modifierKey) {
        const { sku } = this.props.item;
        const stateOption = StateOptions.find(t => t.type === sku) || 
                           StateOptions.find(t => t.type === 'default');
        
        const forwardDataTypes = stateOption?.forwardDataTypes || {};
        
        // Find the modifier in forwardDataTypes
        for (const forwardType of Object.values(forwardDataTypes)) {
            if (forwardType.calculation && forwardType.calculation.id === modifierKey) {
                return forwardType.calculation;
            }
        }
        
        return null;
    }

    getModifierFromAccount(modifierKey) {
        // Use the organisationDefaultModifiers from the asset state
        return this.state.asset.organisationDefaultModifiers[modifierKey] || null;
    }

    getModifierCurrentSource(modifierKey) {
        const asset = this.state.asset || {};
        const modifierLevel = (asset.modifierLevel && asset.modifierLevel[modifierKey]) || null;

        // If explicitly set to platform, use platform
        if (modifierLevel === 'platform') {
            return 'platform';
        }

        // If explicitly set to another level, use that
        if (modifierLevel) {
            return modifierLevel;
        }

        // Defensive: check each level exists and is an object
        const defaultModifiers = (asset.defaultModifiers && typeof asset.defaultModifiers === 'object') ? asset.defaultModifiers : {};
        const siteDefaultModifiers = (asset.siteDefaultModifiers && typeof asset.siteDefaultModifiers === 'object') ? asset.siteDefaultModifiers : {};
        const organisationDefaultModifiers = (asset.organisationDefaultModifiers && typeof asset.organisationDefaultModifiers === 'object') ? asset.organisationDefaultModifiers : {};

        // Default fallback: device > site > organisation > platform
        if (defaultModifiers[modifierKey]) {
            return 'asset';
        }
        if (siteDefaultModifiers[modifierKey]) {
            return 'site';
        }
        if (organisationDefaultModifiers[modifierKey]) {
            return 'organisation';
        }

        return 'platform';
    }

    getSourceBadge(source) {
        const badgeConfig = {
            platform: { 
                text: 'Platform Default', 
                class: 'platform-badge',
                icon: 'FiGlobe'
            },
            organisation: { 
                text: 'Organization Level', 
                class: 'org-badge',
                icon: 'FiUsers'
            },
            site: { 
                text: 'Site Level', 
                class: 'site-badge',
                icon: 'FiMapPin'
            },
            asset: { 
                text: 'Device Level', 
                class: 'asset-badge',
                icon: 'FiSettings'
            }
        };
        
        const config = badgeConfig[source] || badgeConfig.platform;
        
        return (
            <span className={`source-badge ${config.class}`}>
                <Icon icon={config.icon} size={12} style={{ marginRight: '4px' }} />
                {config.text}
            </span>
        );
    }

    checkModifierExists(modifierKey, level) {
        switch (level) {
            case 'asset':
                return !!this.state.asset.defaultModifiers[modifierKey];
            case 'site':
                return !!this.state.asset.siteDefaultModifiers[modifierKey];
            case 'organisation':
                return !!this.state.asset.organisationDefaultModifiers[modifierKey];
            case 'platform':
                return !!this.getModifierFromStateOptions(modifierKey);
            default:
                return false;
        }
    }

    getModifierSourceOptions(modifierKey) {
        const currentSource = this.getModifierCurrentSource(modifierKey);
        
        const options = [
            {
                key: 'platform',
                title: 'Platform Default',
                description: currentSource === 'platform' 
                    ? 'Currently using platform default (cannot be edited)'
                    : 'Switch to platform default (cannot be edited)',
                icon: 'FiGlobe',
                color: '#1976d2',
                action: 'switch'
            }
        ];

        // Organization level option
        if (this.checkModifierExists(modifierKey, 'organisation')) {
            options.push({
                key: 'organisation',
                title: 'Organization Level',
                description: currentSource === 'organisation'
                    ? 'Currently using organization-level settings'
                    : 'Switch to organization-level settings',
                icon: 'FiUsers',
                color: '#f57c00',
                action: 'switch'
            });
        } else {
            options.push({
                key: 'organisation',
                title: 'Organization Level',
                description: 'Create organization-level settings',
                icon: 'FiUsers',
                color: '#f57c00',
                action: 'create'
            });
        }

        // Site level option
        if (this.checkModifierExists(modifierKey, 'site')) {
            options.push({
                key: 'site',
                title: 'Site Level',
                description: currentSource === 'site'
                    ? 'Currently using site-level settings'
                    : 'Switch to site-level settings',
                icon: 'FiMapPin',
                color: '#9c27b0',
                action: 'switch'
            });
        } else {
            options.push({
                key: 'site',
                title: 'Site Level',
                description: 'Create site-level settings',
                icon: 'FiMapPin',
                color: '#9c27b0',
                action: 'create'
            });
        }

        // Device level option
        if (this.checkModifierExists(modifierKey, 'asset')) {
            options.push({
                key: 'asset',
                title: 'Device Level',
                description: currentSource === 'asset'
                    ? 'Currently using device-level settings (can be edited)'
                    : 'Switch to device-level settings',
                icon: 'FiSettings',
                color: '#388e3c',
                action: 'switch'
            });
        } else {
            options.push({
                key: 'asset',
                title: 'Device Level',
                description: 'Create device-level settings',
                icon: 'FiSettings',
                color: '#388e3c',
                action: 'create'
            });
        }

        return options;
    }

    async handleModifierSourceSelect(modifierKey, source) {
        
        if (source === 'platform') {
            // Set to platform - this overrides all other defaults
            this.setState(prevState => ({
                asset: {
                    ...prevState.asset,
                    modifierLevel: {
                        ...prevState.asset.modifierLevel,
                        [modifierKey]: 'platform'
                    }
                },
                hasChanged: true
            }));
        } else {
            // Check if modifier already exists at this level
            const exists = this.checkModifierExists(modifierKey, source);
            
            if (exists) {
                // Just switch to existing level - no modal needed
                this.setState(prevState => ({
                    asset: {
                        ...prevState.asset,
                        modifierLevel: {
                            ...prevState.asset.modifierLevel,
                            [modifierKey]: source
                        }
                    },
                    hasChanged: true
                }));
            } else {
                // Create new modifier at this level
                const platformModifier = this.getModifierFromStateOptions(modifierKey);
                if (platformModifier) {
                    const modifierToEdit = JSON.parse(JSON.stringify(platformModifier));
                    
                    this.setState({ 
                        showModifiersModal: true, 
                        editingModifier: modifierKey,
                        editingDefaults: source === 'asset' ? false : source,
                        creatingNewModifier: true,
                        modifierToEdit: modifierToEdit
                    });
                }
            }
        }
    }

    showModifiersModal() {
        this.setState({ showModifiersModal: true });
    }

    hideModifiersModal() {
        this.setState({ 
            showModifiersModal: false, 
            editingModifier: null,
            creatingNewModifier: false,
            modifierToEdit: null
        });
    }

    onModifiersModalClose = (shouldReload = false) => {
        this.hideModifiersModal();
        if (shouldReload) {
            // Reload the asset data to get the latest modifiers
            this.setAssetDetails();
        }
    }

    async getGateways(searchTerm) {
        if (searchTerm && searchTerm.length) {
            let site_gws = await GridDuck.getGateways({
                filters: [{
                    field: 'search',
                    value: searchTerm
                }]
            });
            return site_gws.list
                .filter(s => s._permission === 'admin')
                .map(
                    s => ({
                        id: s.id,
                        title: s.name
                    })
                )
        } else return []
    }

    async getSites(searchTerm, reset, pageNo) {
        if (!pageNo) {
            pageNo = 0;
        }
        if (searchTerm && searchTerm.length) {
            let sites = await GridDuck.getSites({
                offset: 25 * pageNo,
                filters: [{
                    field: 'search',
                    value: searchTerm
                }]
            });

            return sites.list
                .filter(s => s._permission === 'admin')
                .map(
                    s => ({
                        id: s.id,
                        title: s.name
                    })
                )
        } else return []
    }

    handleClose() {
        this.setState({open: false})
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.item && this.props.item && prevProps.item.id !== this.props.item.id) {
            this.setAssetDetails();
            this.getDeviceCategory().then((res) => this.setState({deviceCategories: res}))
        }
    }

    async componentDidMount() {
        let promises = [
            this.getApplianceTypes(),
            this.getDeviceCategory(),
            this.getModbusModels()
        ]
        let res = await Promise.all(promises)
        this.state.asset['modbusType'] = res[2].find((model) => model.id === this.props.item.modbusId)?.title;
        res[1].push({id: 'null', title: 'None'})
        this.setState({
            applianceTypes: res[0],
            deviceCategories: res[1],
            modbusModels: res[2],
            asset: this.state.asset,
        }, () => {
            this.syncDeviceCategory(() => this.setState({loaded: true}));
        })
    }

    async getModbusModels() {
        let res = await GridDuck.getModbusModels({filters: []})
        let list = res.list.map(
            s => ({
                id: s.id,
                title: s.displayName,
            })
        )
        return Promise.resolve(list)
    }

    async getDeviceCategory() {
        let filters = [{
            field: 'assetIds',
            value: [this.props.item.id]
        }]

        let res = await GridDuck.getDeviceCategorys({
            filters: filters
            // filters: []
        })
        let list = res.list.map(
            s => ({
                id: s.id,
                title: s.name,
                color: s.colour,
                icon: s.icon
            })
        )
        let addNewElement =
            {
                id: 'add_new',
                value: 'add_new',
                title: 'Create New',
                color: '#49b9c4',
                icon: 'FaPlus'
            }
        list.unshift(addNewElement)
        return Promise.resolve(list)
    }

    checkErrors() {
        let errors = {};
        if (!this.state.asset.name.length) errors['name'] = true;
        if (this.props.item.sku === 'MET-REA' && (!this.state.asset.impKwh)) errors['impKwh'] = true;
        this.errors = errors;
    }

    setAssetDetails() {
        let prevApplianceType;
        prevApplianceType = this.state.applianceTypes.find((t) => t.title === this.props.item.applianceType)
        if (!prevApplianceType) prevApplianceType = this.state.applianceTypes.find((t) => t.id === this.props.item.applianceType)
        this.setState({
            loaded: false,
            asset: {
                name: this.props.item.name,
                impKwh: this.props.item.dataType === 'DELIVERED_GAS' ? 1 / this.props.item.impKwh : this.props.item.impKwh,
                gatewayId: this.props.item.gatewayId,
                gatewayName: this.props.item.gatewayName,
                siteName: this.props.item.siteName,
                siteId: this.props.item.siteId,
                dataType: this.props.item.dataType,
                locked: this.props.item.locked,
                modbusType: this.state.modbusModels.find((model) => model.id === this.props.item.modbusId)?.title,
                loadType: this.loadTypes.find((t) => t.id === this.props.item.loadType)?.value || this.loadTypes[0].value,
                defaultModifiers: this.props.item.defaultModifiers || {},
                siteDefaultModifiers: this.props.item.siteDefaultModifiers || {},
                organisationDefaultModifiers: this.props.item.organisationDefaultModifiers || {},
                modifierLevel: this.props.item.modifierLevel || null
            },
            deviceCategory: null,
            applianceType: this.props.item.applianceType,
            generation: this.props.item.generation,
            hasChanged: false
        });

        this.syncDeviceCategory(() => this.setState({loaded: true}));
        if (prevApplianceType) {
            this.setState({applianceType: prevApplianceType.title})
        } else {
            this.setState({applianceType: null});
        }
    }

    getApplianceTypes() {
        return GridDuck.getApplianceTypes({
            sortBy: {
                field: 'name',
                type: 'asc'
            },
            filters: [
                {
                    field: 'search',
                    value: ''
                }
            ]
        }).then((catList) => {
            return Promise.resolve(
                catList.list
                    .map(
                        c => ({
                            id: c.id,
                            title: c.name
                        })
                    )
            )
        })
    }

    saveChanges(e) {
        this.setState({triedToSave: true})
        if (Object.keys(this.errors).length > 0) return new Promise(function (resolve, reject) {
            return reject();
        }).catch(function (resolve, reject) {
            return reject();
        });
        if (e) {
            e.preventDefault();
        }
        let self = this;
        let applianceType = this.state.applianceType;
        let obj = {
            name: this.state.asset.name,
            impKwh: this.state.asset.dataType === 'DELIVERED_GAS' ? 1 / this.state.asset.impKwh : this.state.asset.impKwh,
            locked: this.state.asset.locked,
            generation: this.state.generation,
            loadType: this.loadTypes.find((l) => l.value === this.state.asset.loadType).id,
            deviceCategoryId: this.state.deviceCategory.id,
            modbusId: this.state.modbusModels.find((model) => model.title === this.state.asset.modbusType)?.id || null,
            // Only include modifier fields if they've changed compared to the original item
            ...(JSON.stringify(this.state.asset.defaultModifiers) !== JSON.stringify(this.props.item.defaultModifiers) && {
                defaultModifiers: this.state.asset.defaultModifiers
            }),
            ...(JSON.stringify(this.state.asset.siteDefaultModifiers) !== JSON.stringify(this.props.item.siteDefaultModifiers) && {
                siteDefaultModifiers: this.state.asset.siteDefaultModifiers
            }),
            ...(JSON.stringify(this.state.asset.organisationDefaultModifiers) !== JSON.stringify(this.props.item.organisationDefaultModifiers) && {
                organisationDefaultModifiers: this.state.asset.organisationDefaultModifiers
            }),
            modifierLevel: this.state.asset.modifierLevel
        }
        if (this.state.asset.groupIds && this.state.asset.groupIds !== this.props.item.groupIds) {
            obj.groupIds = this.state.asset.groupIds;
        }
        if (this.props.item.gatewayId !== this.state.asset.gatewayId) {
            obj.gatewayId = this.state.asset.gatewayId;
        }
        if (applianceType) {
            obj.applianceType = applianceType;
        }
        if (this.state.asset.dataType) {
            obj.dataType = this.state.asset.dataType;
        }
        return this.props.item.set(obj).then(function () {
            self.setState({open: true, hasChanged: false})
            self.setAssetDetails();
        });
    }

    cancelChanges() {
        this.setAssetDetails();
    }


    selectDeviceCategory(val, option) {
        if (val.target.value === 'add_new') {
            val.stopPropagation();
            val.preventDefault();
            return this.setState({showDeviceCategoryModal: true})
        }
        this.setState({deviceCategory: option.props.item, hasChanged: true});

    }

    async onFormChange(val, option) {
        if (val.target.name === 'applianceType') {
            this.state.applianceType = val.target.value
        } else {
            this.state.asset[val.target.name] = val.target.value;
        }
        this.setState({asset: this.state.asset, applianceType: this.state.applianceType, hasChanged: true});
    }

    showDeleteModal() {
        this.setState({showDeleteModal: true})
    }

    hasChanged() {
        let self = this;
        let hasChanged = false;

        if (self.props.item && self.state.asset && this.props.loaded) {
            if (self.state.applianceType !== self.props.item.applianceType) {
                let applianceType = this.state.applianceTypes ? this.state.applianceTypes.find((t) => t && t.id === self.props.item.applianceType || t.title === self.props.item.applianceType) : null;
                if ((applianceType && applianceType.id !== self.props.item.applianceType) || (!applianceType && self.state.applianceType)) {
                    hasChanged = true;
                }
            }
            if (self.state.generation !== self.props.item.generation) {
                hasChanged = true
            }
            Object.entries(self.props.item).map(([key, value]) => {
                let updatedKey = key.replace(/^_+/i, '');
                if ((updatedKey in self.state.asset) && self.state.asset[updatedKey] !== value) {
                    hasChanged = true;
                }
            })
        }
        return hasChanged;
    }

    render() {
        let self = this;
        let assetType = this.props.item && this.props.item.sku ? StateOptions.find(o => o.type === this.props.item.sku) || StateOptions.find(o => o.type === 'default') : StateOptions.find(o => o.type === 'default');
        this.checkErrors();
        let footerSaveBar = this.state.hasChanged ?
            <div className={'detail-content'}>
                <SaveBar onSaveClick={this.saveChanges} onCancelClick={this.cancelChanges}/></div> : '';

        let generalCard;
        let advancedCard;
        let impKwhBr;
        let impKwhField;
        if (this.props.item && this.props.item.sku && (this.props.item.sku === 'MET-REA' || this.props.item.sku === 'MET-REA_FRIENT' || this.props.item.sku.substr(0, 9) === 'BLE_PULSE' || this.props.item.sku.substr(0, 12) === 'NB-IOT-PULSE')) {
            let unit = 'Impressions per kWh';
            if (this.state.asset.dataType === 'DELIVERED_WATER') {
                unit = 'Impressions per m3'
            }
            if (this.state.asset.dataType === 'DELIVERED_GAS') {
                unit = 'm3 per impression'
            }
            if (this.state.asset.dataType === 'DELIVERED_WATER_HOT') {
                unit = 'Impressions per m3'
            }
            impKwhBr = (<br/>);
            impKwhField = (<Input error={this.errors['impKwh'] && this.state.triedToSave} onKeyPress={(event) => {
                if (event.key === 'Enter') this.saveChanges();
            }} label={unit} required name={'impKwh'}
                                  value={this.state.asset.impKwh}
                                  disabled={this.props.item._permission !== 'admin' && this.props.item._permission !== 'edit'}
                                  onChange={this.onFormChange}/>);
        }
        let applianceTypeField;
        let dataTypeField;
        let applianceLockOption;
        if (this.props.item.sku && assetType.options.find(o => o.state === 'ON') !== undefined) {
            applianceLockOption = (
                <div className={'settings-row'}>
                    <Toggle
                        disabled={this.props.item._permission !== 'admin' && this.props.item._permission !== 'edit'}
                        onClick={() => {
                            let locked = !self.state.asset.locked;
                            return this.onFormChange({target: {name: 'locked', value: locked}})
                        }}
                        name={'locked'}
                        inactivestatename={'Monitoring Only'}
                        activestatename={'Monitoring Only'}
                        active={this.state.asset.locked ? 'true' : 'false'}
                    />
                </div>
            )
        }
        let loadTypeField;
        if (this.props.item && this.props.item.sku && (this.props.item.sku === 'SEN-POW-OWON-OLD' || this.props.item.sku === 'SEN-POW-OWON' || this.props.item.sku.indexOf('VIRTUAL-PARENT') !== -1)) {
            loadTypeField = <div className={'settings-row'}>
                <Dropdown
                    name={'loadType'}
                    value={this.state.asset.loadType}
                    fixeditems={this.loadTypes}
                    disabled={this.props.item._permission !== 'admin' && this.props.item._permission !== 'edit'}
                    placeholder={'Select Load Type'}
                    label="Load Type"
                    onChange={(var1, var2) => this.onFormChange(var1, var2)}
                />
            </div>
        }
        let modbusTypeField;
        if (this.props.item && this.props.item.sku && (this.props.item.sku === 'MODBUS')) {
            modbusTypeField = <div className={'settings-row'}>
                <Dropdown
                    name={'modbusType'}
                    value={this.state.asset.modbusType}
                    fixeditems={this.state.modbusModels}
                    disabled={this.props.item._permission !== 'admin' && this.props.item._permission !== 'edit'}
                    placeholder={'Select Modbus Type'}
                    label="Modbus Type"
                    onChange={(var1, var2) => this.onFormChange(var1, var2)}
                />
            </div>
        }

        if (this.props && this.props.item && this.props.item.sku && this.props.item.sku.substr(0, 12) !== 'NB-IOT-PULSE' && this.props.item.sku.substr(0, 9) !== 'BLE_PULSE' && this.props.item.sku !== 'SEN-TEM-HUM' && this.props.item.sku !== 'SEN-LIGHT-MOTION') {
            // applianceTypeField = (<div className={'settings-row'}>
            //     <Dropdown
            //         name={'applianceType'}
            //         value={this.state.applianceType}
            //         fixeditems={this.state.applianceTypes}
            //         disabled={this.props.item._permission !== 'admin' && this.props.item._permission !== 'edit'}
            //         placeholder={'Device Label'}
            //         label="Device Label"
            //         onChange={(var1, var2) => this.onFormChange(var1, var2)}
            //     />
            // </div>)

        } else if (this.props && this.props.item && this.props.item.sku && this.props.item.sku !== 'SEN-TEM-HUM' && this.props.item.sku !== 'SEN-LIGHT-MOTION') {
            dataTypeField = (
                <div className={'settings-row'}>
                    <Dropdown
                        name={'dataType'}
                        value={this.state.asset.dataType}
                        fixeditems={[
                            {value: 'DELIVERED', title: 'Electricity'},
                            {value: 'DELIVERED_GAS', title: 'Gas'},
                            {value: 'DELIVERED_WATER', title: 'Water'},
                            {value: 'DELIVERED_WATER_HOT', title: 'Hot water'}
                        ]}
                        disabled={this.props.item._permission !== 'admin' && this.props.item._permission !== 'edit'}
                        placeholder={'Meter Type'}
                        label="Meter Type"
                        onChange={(var1, var2) => this.onFormChange(var1, var2)}
                    />
                </div>
            )
        }

        let deviceCategoryField;

        if (this.state.showDeviceCategoryModal || !this.state.deviceCategories.length || !this.state.deviceCategory) {
            deviceCategoryField = (
                <div className={'settings-row'}>
                    <Loader type={'circular'} size={24}/>
                </div>
            )
        } else {
            deviceCategoryField = (
                <div className={'settings-row'}>
                    <Dropdown
                        name={'deviceCategory'}
                        value={this.state.deviceCategory.title}
                        fixeditems={this.state.deviceCategories}
                        disabled={this.props.item._permission !== 'admin' && this.props.item._permission !== 'edit'}
                        placeholder={'Device Category'}
                        label="Device Category"
                        onChange={(var1, var2) => this.selectDeviceCategory(var1, var2)}
                    />
                </div>
            )
        }

        if (this.props.item) {
            generalCard = (
                <Card className={'asset-general-settings'}>
                    <CardHeader title={'General'}/>
                    <CardBody>
                        <Input error={this.errors['name'] && this.state.triedToSave} onKeyPress={(event) => {
                            if (event.key === 'Enter') this.saveChanges();
                        }} top='true' label={'Name'} required name={'name'} value={this.state.asset.name}
                               onChange={this.onFormChange}
                               disabled={this.props.item._permission !== 'admin' && this.props.item._permission !== 'edit'}
                        />
                        {applianceTypeField}
                        {deviceCategoryField}
                        {applianceLockOption}
                        {dataTypeField}
                        {impKwhField}
                        {impKwhBr}
                        {loadTypeField}
                        {modbusTypeField}
                    </CardBody>
                </Card>
            )
            advancedCard = (
                <Card>
                    <CardHeader title={'Advanced'}/>
                    <CardBody>
                        {this.props.item.sku !== 'VIRTUAL-PARENT' ?
                            <GdAutocomplete async name={'gatewayId'} getOptionSelected={function (option, value) {
                                if (option && value) return option.id === value.id;
                            }}
                                            value={this.state.asset.gatewayName}
                                            placeholder={'Search Gateways'}
                                            getList={self.getGateways}
                                            onChange={this.selectGateway} label="Move Hub"/> : ''}
                        <br/>
                        {this.props.item.sku !== 'VIRTUAL-PARENT' ?
                            <GdAutocomplete async name={'groupIds'} getOptionSelected={function (option, value) {
                                if (option && value) return option.id === value.id;
                            }}
                                            value={this.state.asset.siteName}
                                            placeholder={'Search Sites'}
                                            getList={self.getSites}
                                            onChange={this.selectSite} label="Move Site"/> : ''}
                        <br/>
                        {this.props.item._permission === 'admin' ?
                            <Button label={'Delete Device'} color={'gd-red'} onClick={this.showDeleteModal}/> : ''}
                    </CardBody>
                </Card>
            )
        }

        return (
            <div className={"page grey narrow not-flex"}>
                {this.state.loaded ? <div className={'column top'}>
                    <div className={'detail-content'}>
                        {generalCard}

                    </div>
                    {this.props.item && this.props.item.sku && this.props.item.sku.indexOf('VIRTUAL-PARENT') === -1 && Object.keys(this.getMergedModifiers()).length > 0 && (
                        <div className={'detail-content'}>
                            <Card>
                                <CardHeader title={'Data Calculations'}/>
                                <CardBody>
                                    <div className="modifiers-list-container">
                                        {this.renderModifiersList()}
                                    </div>
                                </CardBody>
                            </Card>
                        </div>
                    )}
                    <div className={'detail-content'}>
                        {this.props.item._permission === 'admin' ? advancedCard : null}
                    </div>
                
                    {footerSaveBar}
                </div> : <GenericLoader/>}
                {this.state.showDeviceCategoryModal ? <AddEditDeviceCategoryModal
                    onClose={() => {
                        this.getDeviceCategory().then((res) => {
                            this.setState({deviceCategories: res, showDeviceCategoryModal: null})
                        })
                    }}
                    open={!!this.state.showDeviceCategoryModal}
                    item={this.state.showDeviceCategoryModal}
                    setNewDeviceCategory={(deviceCategory) => {
                        let val = {
                            target: {
                                name: 'deviceCategory',
                                value: deviceCategory
                            }
                        }
                        this.onFormChange(val).then(() => this.saveChanges())
                    }
                    }
                /> : ''}
                <DeleteModal
                    itemType={'device'}
                    item={this.props.item}
                    open={this.state.showDeleteModal}
                    onClose={() => this.setState({showDeleteModal: false})}/>
                <ModifiersModal
                    open={this.state.showModifiersModal}
                    onClose={this.onModifiersModalClose}
                    value={this.getMergedModifiers()}
                    asset={this.props.item}
                    editingModifier={this.state.editingModifier}
                    editingDefaults={this.state.editingDefaults}
                    creatingNewModifier={this.state.creatingNewModifier}
                    modifierToEdit={this.state.modifierToEdit}
                />
                <Toast onClose={this.handleClose} message={"Save Successful"}
                       anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
                       open={this.state.open}/>
            </div>
        )
    }
}

export default AssetSettingsDetails;